var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-header"},[_c('div',{staticClass:"back_left",on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('div',{staticClass:"big_tit"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }